import { default as files } from "components/fileViewers/logic/actions";
import { default as pdf } from "components/fileViewers/logic/pdfActions";
import { combineReducers } from "redux";
import { default as advertising2 } from "./components/advertising/logic/adActions";
import { default as advertising } from "./components/advertising/logic/formActions";
import { default as contacts } from "./components/contact/logic/contactActions";
import { default as filmReleaseForm } from "./components/film/logic/filmFormActions";
import { default as filmReleaseList } from "./components/film/logic/filmListActions";
import { reducer as globalApp } from "./components/global/logic/actions";
import { default as login } from "./components/login/logic/actions";
import { default as relatedFilmsForm } from "./components/relatedFilms/logic/relatedFilmsFormActions";
import { default as reportAdv } from "./components/report/advertising/logic/advReportActions";
import { default as reportLog } from "./components/report/logsheet/logic/logReportActions";
import { default as review } from "./components/review/logic/actions";
import { default as apiImport } from "./components/settings/apiImport/logic/actions";
import { default as tagSettings } from "./components/settings/tags/logic/actions";
import { default as templateSettings } from "./components/settings/templates/logic/actions";
import { default as userForm } from "./components/settings/user/form/logic/actions";
import { default as users } from "./components/settings/user/list/logic/actions";
import { reducer as statistics } from "./components/statistics/logic/actions";
export default combineReducers({
    globalApp,
    login,
    advertising,
    tagSettings,
    templateSettings,
    statistics,
    review,
    filmReleaseForm,
    filmReleaseList,
    reportAdv,
    reportLog,
    pdf,
    relatedFilmsForm,
    contacts,
    apiImport,
    users,
    userForm,
    files,
    advertising2,
});
